import { CallIntelligenceService } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2/call_intelligence.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCallIntelligenceV2Service = bindHTTP(CallIntelligenceService);
export const serviceName = 'call-intelligence-v2' as const;
